export default "__VITE_ASSET__BFCi9kVi__"